module.exports = __webpack_public_path__ + "/48bd7cfac26b69463eca574486bdb97c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/header/signdoc_icon@2x.png
 ** module id = 707
 ** module chunks = 0
 **/